import * as yup from 'yup';

const AccountDeletionRequestValidation = yup.object()
  .shape({
    message: yup
      .string()
      .max(1000, 'Message must be less than 1000 characters')
      .required('Message is required'),

  });

export default AccountDeletionRequestValidation;
